import { render, staticRenderFns } from "./FlightDataCard.vue?vue&type=template&id=79df30f2&scoped=true"
import script from "./FlightDataCard.vue?vue&type=script&lang=js"
export * from "./FlightDataCard.vue?vue&type=script&lang=js"
import style0 from "./FlightDataCard.vue?vue&type=style&index=0&id=79df30f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79df30f2",
  null
  
)

export default component.exports